<div class="loading-overlay" *ngIf="loading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="min-h-screen bg-white">
  <div class="max-w-full mx-auto py-6">
        <div *ngIf="!isAdmin && !isSousAdmin" class="mb-6">
          <app-credit-disponible></app-credit-disponible>
        </div>


        <div class="suivi-table-container">
          <div class="py-4 border-b border-gray-200 flex items-center gap-4 relative" [style.padding-left.px]="headerPaddingLeft" [style.padding-right.px]="headerPaddingRight">
            <div class="flex items-center gap-3 flex-shrink-0 suivi-buttons-left-container">
              <button 
                class="relancer-delivered-btn bg-white rounded-full px-3 py-2 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm overflow-hidden disabled:opacity-50 disabled:cursor-not-allowed"
                (click)="relancerTousDelivered()" 
                [disabled]="loading"
                title="Relancer tous les délivrés"
                style="color: #34d399;">
                <span class="material-symbols-outlined text-lg transition-transform duration-200 flex-shrink-0">restart_alt</span>
                <span class="relancer-delivered-text text-sm font-medium whitespace-nowrap">Relancer tous les délivrés</span>
              </button>
              <button 
                class="relancer-failed-btn bg-white rounded-full px-3 py-2 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm overflow-hidden disabled:opacity-50 disabled:cursor-not-allowed"
                (click)="relancerFailed('all')" 
                [disabled]="loading"
                title="Relancer tous les failed"
                style="color: #dc2626;">
                <span class="material-symbols-outlined text-lg transition-transform duration-200 flex-shrink-0">refresh</span>
                <span class="relancer-failed-text text-sm font-medium whitespace-nowrap">Relancer tous les failed</span>
              </button>
            </div>
            
            <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
              <div class="relative w-full max-w-xs">
                <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm pointer-events-none">search</span>
                <input
                  type="text"
                  class="search-input-suivi w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                  [(ngModel)]="searchTerm"
                  placeholder="Rechercher par client ou campagne..."
                />
              </div>
              <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
                {{ filtered.length }} résultat{{ filtered.length > 1 ? 's' : '' }}
              </span>
            </div>
            
            <div class="suivi-buttons-right-container">
              <button 
                type="button"
                class="switch-trigger-btn bg-white hover:bg-blue-50 text-blue-900 rounded-full px-3 py-2 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm overflow-hidden"
                (click)="openSwitchModal()"
                title="Switch SMS Campagne">
                <span class="material-symbols-outlined text-lg transition-transform duration-200 flex-shrink-0">swap_horiz</span>
                <span class="switch-text-hover text-sm font-medium whitespace-nowrap">Switch SMS Campagne</span>
              </button>
              
              <button 
                type="button"
                class="add-campaign-button bg-white hover:bg-blue-50 text-blue-900 rounded-full px-3 py-2 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm overflow-hidden"
                (click)="openAddCampaignModal()"
                title="Ajouter une campagne">
                <span class="material-symbols-outlined text-lg transition-transform duration-200 flex-shrink-0">add</span>
                <span class="add-campaign-button-text text-sm font-medium whitespace-nowrap">Ajouter une campagne</span>
              </button>
            </div>
          </div>

          <div class="p-6">
            <div class="overflow-x-auto w-full" style="overflow-x: visible;">
                <table class="w-full border-collapse bg-white" style="table-layout: auto; width: 100%; min-width: 1400px;">
                <thead>
                  <tr class="bg-gradient-to-r from-gray-50 via-gray-100 to-gray-50">
                    <th *ngIf="isAdmin || isSousAdmin" class="px-0 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 40px; padding-right: 6px;">
                      <button 
                        class="global-play-pause-btn-header"
                        [ngClass]="getGlobalIsOnState() === 'on' ? 'global-play-pause-btn-header-pause' : 'global-play-pause-btn-header-play'"
                        (click)="toggleAllIsOn()" 
                        [disabled]="loading"
                        [title]="getGlobalIsOnState() === 'on' ? 'Arrêter toutes les campagnes et clients SMPP' : 'Démarrer toutes les campagnes et clients SMPP'">
                        <span *ngIf="getGlobalIsOnState() === 'off' || getGlobalIsOnState() === 'mixed'" class="material-symbols-outlined text-lg">play_arrow</span>
                        <span *ngIf="getGlobalIsOnState() === 'on'" class="material-symbols-outlined text-lg">pause</span>
                      </button>
                    </th>
                    <th *ngIf="isAdmin || isSousAdmin" 
                        class="py-3 text-left text-base font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300 cursor-pointer hover:bg-gray-200 transition-colors"
                        style="width: 12%; padding-left: 4px; padding-right: 8px;"
                        (click)="toggleSortClient()">
                      <div class="flex items-center gap-1">
                        <span class="material-symbols-outlined text-lg">people</span>
                        <span>Clients</span>
                        <span *ngIf="sortClientAsc" class="text-blue-600 text-base">▲</span>
                        <span *ngIf="!sortClientAsc" class="text-blue-600 text-base">▼</span>
                      </div>
                    </th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 8%;">
                      Statistiques
                    </th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 6%;">Total</th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 6%;">ReallySend</th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 6%;">Délivrés</th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 6%;">Affectés</th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 6%;">Non affectés</th>
                    <th *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 5%;">Failed</th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 5%;">Doublons</th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 7%; white-space: nowrap;">Too long</th>
                    <th *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 6%;">Ancien blacklist</th>
                    <th *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 6%;">New Blacklist</th>
                    <th *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 5%;">Réponses</th>
                    <th class="px-2 py-3 text-center text-sm font-bold text-gray-700 uppercase tracking-wider border-b-2 border-gray-300" style="width: 12%;">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="hover:bg-blue-50 transition-all duration-150 border-b border-gray-100 group">
                    <td *ngIf="isAdmin || isSousAdmin" class="px-0 py-3 text-center" style="padding-right: 6px;">
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" 
                        class="py-3 text-left font-medium text-base text-gray-900"
                        style="padding-left: 4px; padding-right: 8px;">
                      <div class="flex flex-col gap-1">
                        <div class="flex items-center gap-2">
                          <span class="truncate text-base font-medium">TOTAUX</span>
                        </div>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="suivi-stats-row-modern">
                        <div class="suivi-stat-badge-modern suivi-stat-badge-green" title="Pourcentage de progression">
                          <span class="stat-number">{{ getTotalPercentage() }}%</span>
                        </div>
                        <div class="suivi-stat-badge-modern suivi-stat-badge-red" title="Pourcentage Failed">
                          <span class="stat-number">{{ getTotalFailedPercentage() }}%</span>
                        </div>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ totalEnvoi.total }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-base" style="color: #059669;">{{ totalEnvoi.reallySend }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-base" style="color: #34d399;">{{ totalEnvoi.envoyer }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ totalEnvoi.affected }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-2">
                        <span class="font-semibold text-gray-900 text-base">{{ totalEnvoi.notAffected }}</span>
                        <span *ngIf="needsSchedule" class="schedule-alert-badge" title="Il faut schedule">
                          <span class="material-symbols-outlined text-sm text-amber-600">schedule</span>
                        </span>
                      </div>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <span class="font-semibold text-red-600 text-base">{{ totalEnvoi.failed }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ totalEnvoi.nombreDuplicate }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ totalEnvoi.nombreTooLong }}</span>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">0</span>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ totalEnvoi.nombreStop }}</span>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ totalEnvoi.nombreReception }}</span>
                    </td>
                    <td class="px-2 py-3 text-center"></td>
                  </tr>

                  <ng-container *ngFor="let s of filtered; trackBy: trackBySmppId">
                  <tr *ngIf="s.itemType === 'smpp'" 
                      [ngClass]="s.assezCredit === false ? 'bg-red-50 hover:bg-red-100' : 'hover:bg-blue-50'"
                      class="transition-all duration-150 border-b border-gray-100 group">
                    <td *ngIf="isAdmin || isSousAdmin" class="px-0 py-3 text-center" style="padding-right: 6px;">
                      <button 
                        class="play-pause-btn"
                        [ngClass]="s.isOn === 'on' ? 'play-pause-btn-pause' : 'play-pause-btn-play'"
                        [disabled]="loading"
                        (click)="updateIsOn('users', s._id, s.isOn === 'on' ? 'off' : 'on')"
                        [title]="s.isOn === 'on' ? 'Arrêter' : 'Démarrer'">
                        <span *ngIf="s.isOn === 'off'" class="material-symbols-outlined">play_arrow</span>
                        <span *ngIf="s.isOn === 'on'" class="material-symbols-outlined">pause</span>
                      </button>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" 
                        class="py-3 text-left font-medium text-base"
                        style="padding-left: 4px; padding-right: 8px;"
                        [ngClass]="s.assezCredit === false ? 'text-red-600 font-semibold' : 'text-gray-900'">
                      <div class="flex flex-col gap-1">
                        <div class="client-name-clickable truncate text-base font-medium cursor-pointer inline-block" 
                             [title]="'ID: ' + s._id + ' (cliquez pour copier)'"
                             (click)="copyRefCampagne(s._id, $event)">
                          API ({{ s.identifiant }})
                        </div>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="suivi-stats-row-modern">
                        <div class="suivi-stat-badge-modern suivi-stat-badge-green" title="Pourcentage de progression">
                          <span class="stat-number">{{ getPercentage(s) }}%</span>
                        </div>
                        <div class="suivi-stat-badge-modern suivi-stat-badge-red" title="Pourcentage Failed">
                          <span class="stat-number">{{ getFailedPercentage(s) }}%</span>
                        </div>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterTotal('user', s._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ s.total }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-base" style="color: #059669;">{{ s.reallySend }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-base" style="color: #34d399;">{{ s.envoyer }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ s.affected || 0 }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ s.notAffected || 0 }}</span>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterFailed('user', s._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-red-600 text-base">{{ s.failed }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterDuplicate('user', s._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ s.nombreDuplicate }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterTooLong('user', s._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ s.nombreTooLong }}</span>
                      </div>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">0</span>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterStop('user', s._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ s.nombreStop }}</span>
                      </div>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterReceptions('user', s._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ s.nombreReception }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="actions-row-modern">
                        <button 
                          type="button"
                          class="btn-action-modern btn-reload-delivered"
                          (click)="relancerDelivered()"
                          title="Relancer délivrés">
                          <span class="material-symbols-outlined">restart_alt</span>
                        </button>
                        <button 
                          type="button"
                          class="btn-action-modern btn-reload-failed"
                          (click)="relancerFailed('user', s._id)"
                          title="Relancer failed">
                          <span class="material-symbols-outlined">refresh</span>
                        </button>
                        <button 
                          type="button"
                          class="btn-action-modern btn-delete-attente"
                          (click)="supprimerSMPP(s._id, 0)"
                          title="Supprimer en attente">
                          <span class="material-symbols-outlined">hourglass_empty</span>
                        </button>
                        <button 
                          type="button"
                          class="btn-action-modern btn-delete-total"
                          (click)="supprimerSMPP(s._id, 1)"
                          title="Supprimer total">
                          <span class="material-symbols-outlined">delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </ng-container>

                  <ng-container *ngFor="let c of filtered; trackBy: trackByCampagneId">
                  <tr *ngIf="c.itemType === 'campagne'" 
                      [ngClass]="c.assezCredit === false ? 'bg-red-50 hover:bg-red-100' : 'hover:bg-blue-50'"
                      class="transition-all duration-150 border-b border-gray-100 group">
                    <td *ngIf="isAdmin || isSousAdmin" class="px-0 py-3 text-center" style="padding-right: 6px;">
                      <button 
                        class="play-pause-btn"
                        [ngClass]="c.isOn === 'on' ? 'play-pause-btn-pause' : 'play-pause-btn-play'"
                        [disabled]="loading"
                        (click)="updateIsOn('campagnes', c._id, c.isOn === 'on' ? 'off' : 'on')"
                        [title]="c.isOn === 'on' ? 'Arrêter' : 'Démarrer'">
                        <span *ngIf="c.isOn === 'off'" class="material-symbols-outlined">play_arrow</span>
                        <span *ngIf="c.isOn === 'on'" class="material-symbols-outlined">pause</span>
                      </button>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" 
                        class="py-3 text-left font-medium text-base"
                        style="padding-left: 4px; padding-right: 8px;"
                        [ngClass]="c.assezCredit === false ? 'text-red-600 font-semibold' : 'text-gray-900'">
                      <div class="flex flex-col gap-1">
                        <div class="client-name-clickable truncate text-base font-medium cursor-pointer inline-block" 
                             [title]="'ID: ' + c._id + ' (cliquez pour copier)'"
                             (click)="copyRefCampagne(c._id, $event)">
                          {{ c.typeClient === 'SMPP' ? 'API (' + c.nomClient + ')' : c.nomClient }}
                        </div>
                        <div class="text-sm text-gray-400 flex items-center gap-1">
                          <span class="material-symbols-outlined text-sm">schedule</span>
                          <span class="truncate max-w-[200px]">{{ formatDateCampagne(c) }}</span>
                        </div>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="suivi-stats-row-modern">
                        <div class="suivi-stat-badge-modern suivi-stat-badge-green" title="Pourcentage de progression">
                          <span class="stat-number">{{ getPercentage(c) }}%</span>
                        </div>
                        <div class="suivi-stat-badge-modern suivi-stat-badge-red" title="Pourcentage Failed">
                          <span class="stat-number">{{ getFailedPercentage(c) }}%</span>
                        </div>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterTotal('campagne', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.total }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-base" style="color: #059669;">{{ c.reallySend }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-base" style="color: #34d399;">{{ c.envoyer }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ c.affected || 0 }}</span>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-900 text-base">{{ c.notAffected || 0 }}</span>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterFailed('campagne', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-red-600 text-base">{{ c.failed }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterDuplicate('campagne', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.nombreDuplicate }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterTooLong('campagne', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.nombreTooLong }}</span>
                      </div>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <span class="font-semibold text-gray-500 text-xs">Ancien BL</span>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterStop('campagne', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.nombreStop }}</span>
                      </div>
                    </td>
                    <td *ngIf="isAdmin || isSousAdmin" class="px-2 py-3 text-center">
                      <div class="flex items-center justify-center gap-1">
                        <button 
                          class="p-1 rounded text-gray-500 hover:bg-blue-100 hover:text-blue-600 transition-all duration-200"
                          (click)="exporterReceptions('campagne', c._id)" 
                          title="Télécharger">
                          <span class="material-symbols-outlined text-sm">download</span>
                        </button>
                        <span class="font-semibold text-gray-900 text-base">{{ c.nombreReception }}</span>
                      </div>
                    </td>
                    <td class="px-2 py-3 text-center">
                      <div class="actions-row-modern">
                        <button 
                          type="button"
                          class="btn-action-modern btn-reload-delivered"
                          (click)="relancerDelivered()"
                          title="Relancer délivrés">
                          <span class="material-symbols-outlined">restart_alt</span>
                        </button>
                        <button 
                          type="button"
                          class="btn-action-modern btn-reload-failed"
                          (click)="relancerFailed(c._id)"
                          title="Relancer failed">
                          <span class="material-symbols-outlined">refresh</span>
                        </button>
                        <button 
                          type="button"
                          class="btn-action-modern btn-delete"
                          (click)="supprimer(c._id)"
                          title="Supprimer">
                          <span class="material-symbols-outlined">delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </ng-container>
                </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
</div>

<div class="switch-modal-overlay" *ngIf="showSwitchModal">
  <div class="switch-modal-content" #switchModalContent>
    <div class="switch-modal-header">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <span class="material-symbols-outlined text-white text-lg">swap_horiz</span>
        </div>
        <h2 class="text-lg font-semibold text-gray-900">Switch SMS Campagne</h2>
      </div>
      <button 
        class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 text-gray-400 hover:text-gray-600"
        (click)="closeSwitchModal()" 
        type="button"
        [disabled]="isSwitching">
        <span class="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
    
    <div class="switch-modal-body">
      <form (ngSubmit)="switchCampaignSmpp(); $event.preventDefault()" id="switchForm">
        <div class="space-y-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              Client A (Source)
              <span class="text-red-500">*</span>
            </label>
            <select 
              class="switch-form-select" 
              [(ngModel)]="selectedUserA" 
              name="selectedUserA" 
              required
              [disabled]="isSwitching || loading">
              <option value="" disabled selected>Choisir un client</option>
              <option *ngFor="let user of getAvailableUsersA()" [value]="user._id">{{ user.identifiant }}</option>
            </select>
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              Client B (Destination)
              <span class="text-red-500">*</span>
            </label>
            <select 
              class="switch-form-select" 
              [(ngModel)]="selectedUserB" 
              name="selectedUserB" 
              required
              [disabled]="isSwitching || loading">
              <option value="" disabled selected>Choisir un client</option>
              <option *ngFor="let user of getAvailableUsersB()" [value]="user._id">{{ user.identifiant }}</option>
            </select>
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              Filtre texte (optionnel)
            </label>
            <input 
              type="text"
              class="switch-form-input" 
              [(ngModel)]="switchText" 
              name="switchText" 
              placeholder="Filtre texte..."
              [disabled]="isSwitching || loading" />
          </div>

          <div class="bg-blue-50 border border-blue-200 rounded-lg p-3 mt-4">
            <div class="flex items-start gap-2">
              <span class="material-symbols-outlined text-blue-600 text-sm flex-shrink-0 mt-0.5">info</span>
              <div class="text-xs text-blue-800">
                <p class="font-medium mb-1">Transfert de SMS</p>
                <p class="text-blue-700">Tous les SMS du client A seront transférés vers le client B. Cette action est irréversible.</p>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    
    <div class="switch-modal-footer">
      <button 
        type="button" 
        class="switch-btn-secondary" 
        (click)="closeSwitchModal()"
        [disabled]="isSwitching">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Annuler</span>
      </button>
      <button 
        type="submit" 
        class="switch-btn-primary" 
        form="switchForm"
        [disabled]="isSwitching || loading || !selectedUserA || !selectedUserB">
        <span *ngIf="!isSwitching" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">swap_horiz</span>
          <span>Transférer</span>
        </span>
        <span *ngIf="isSwitching" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Transfert en cours...</span>
        </span>
      </button>
    </div>
  </div>
</div>

<div class="campaign-modal-overlay" *ngIf="showAddCampaignModal">
  <div class="campaign-modal-content" #addCampaignModalContent>
    <div class="campaign-modal-header">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <span class="material-symbols-outlined text-white text-lg">campaign</span>
        </div>
        <h2 class="text-lg font-semibold text-gray-900">Ajouter une campagne</h2>
      </div>
      <button 
        class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 text-gray-400 hover:text-gray-600"
        (click)="closeAddCampaignModal()" 
        type="button"
        [disabled]="isCreating || upload">
        <span class="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
    
    <div class="campaign-modal-body">
      <form class="space-y-4" (ngSubmit)="premiereCreation(); $event.preventDefault()">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div *ngIf="isAdmin || isSousAdmin" class="campagne-form-group">
            <label class="campagne-label">
              <span class="material-symbols-outlined text-sm mr-1.5">person</span>
              Client concerné
            </label>
            <select 
              class="campagne-input"
              [(ngModel)]="selectedClient"
              name="client"
              [class.border-red-300]="error.client">
              <option value="" disabled selected>Pour le client...</option>
              <option *ngFor="let client of modalClients" [value]="client._id">
                {{ client.identifiant }}
              </option>
            </select>
            <p *ngIf="error.client" class="campagne-error">Merci de choisir le client</p>
          </div>

          <div class="campagne-form-group">
            <label class="campagne-label">
              <span class="material-symbols-outlined text-sm mr-1.5">chat_bubble</span>
              Message identique pour tous ?
            </label>
            <select 
              class="campagne-input"
              [(ngModel)]="nouveauMessage.messageUnique"
              name="messageUnique">
              <option value="1">Le message est le même</option>
              <option value="0">Le message est différent</option>
            </select>
          </div>
        </div>

        <div class="campagne-form-group">
          <label class="campagne-label">
            <span class="material-symbols-outlined text-sm mr-1.5">label</span>
            Référence de la campagne
          </label>
          <input 
            type="text"
            class="campagne-input"
            [(ngModel)]="nouveauMessage.nomCampagne"
            name="nomCampagne"
            placeholder="Référence de la campagne..."
            [class.border-red-300]="error.reference">
          <p *ngIf="error.reference" class="campagne-error">Merci de saisir la référence</p>
        </div>

        <div class="campagne-form-group">
          <label class="campagne-label">
            <span class="material-symbols-outlined text-sm mr-1.5">schedule</span>
            Planification de l'envoi
          </label>
          <div class="planification-toggle-container">
            <div 
              class="planification-option"
              [class.active]="nouveauMessage.isScheduled === '0'"
              (click)="nouveauMessage.isScheduled = '0'">
              <div class="planification-option-content">
                <div class="planification-icon-wrapper">
                  <span class="material-symbols-outlined planification-icon">flash_on</span>
                </div>
                <div class="planification-text">
                  <div class="planification-title">Envoi immédiat</div>
                  <div class="planification-subtitle">Démarrage automatique</div>
                </div>
              </div>
            </div>
            
            <div 
              class="planification-option planification-option-scheduled"
              [class.active]="nouveauMessage.isScheduled === '1'"
              (click)="nouveauMessage.isScheduled = '1'">
              <div class="planification-option-content">
                <div class="planification-icon-wrapper">
                  <span class="material-symbols-outlined planification-icon">calendar_today</span>
                </div>
                <div class="planification-text">
                  <div class="planification-title">Envoi planifié</div>
                  <div class="planification-subtitle">Définir une date</div>
                </div>
                
                <div 
                  class="planification-date-wrapper"
                  *ngIf="nouveauMessage.isScheduled === '1'"
                  (click)="$event.stopPropagation()">
                  <input 
                    type="datetime-local"
                    class="planification-date-input"
                    [(ngModel)]="nouveauMessage.schedule"
                    name="schedule"
                    [class.border-red-300]="error.schedule">
                </div>
              </div>
              <p *ngIf="error.schedule" class="planification-date-error">Merci de saisir une date</p>
            </div>
          </div>
        </div>

        <div 
          class="campagne-form-group campagne-message-container transition-all duration-300 ease-in-out"
          *ngIf="nouveauMessage.messageUnique === '1'"
          [class.animate-fade-in]="nouveauMessage.messageUnique === '1'">
          <label class="campagne-label">
            <span class="material-symbols-outlined text-sm mr-1.5">message</span>
            Message à envoyer
          </label>
          <textarea 
            class="campagne-textarea"
            rows="4"
            placeholder="Message..."
            [(ngModel)]="nouveauMessage.message"
            name="message"
            (input)="control7Encoding()"
            [class.border-red-300]="error.message || error.tooLong"></textarea>
          <div class="flex items-center justify-between mt-1.5">
            <div>
              <span class="text-sm font-medium" [ngClass]="compterTaille() > describedText[0] ? 'text-red-600' : 'text-gray-600'">
                {{ compterTaille() }} / {{ describedText[0] }} caractères
              </span>
              <span class="text-sm text-gray-500 ml-2">GSM {{ describedText[1] }}-bit</span>
            </div>
          </div>
          <p *ngIf="error.message" class="campagne-error">Merci de saisir votre message</p>
          <p *ngIf="error.tooLong" class="campagne-error">Le message est trop long</p>
        </div>

        <div class="campagne-form-group">
          <label class="campagne-label">
            <span class="material-symbols-outlined text-sm mr-1.5">upload_file</span>
            Fichier client (XLSX)
          </label>
          <div class="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-4 text-center transition-colors hover:border-blue-400">
            <div class="flex items-center justify-center gap-3">
              <div class="flex-1">
                <p class="text-sm text-gray-600 mb-2 campagne-file-instruction transition-opacity duration-300 ease-in-out">
                  <span *ngIf="nouveauMessage.messageUnique === '1'" class="inline-block animate-fade-in">1 colonne avec les numéros sans titre</span>
                  <span *ngIf="nouveauMessage.messageUnique === '0'" class="inline-block animate-fade-in">2 colonnes sans titre : numéros + message</span>
                </p>
                <label class="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg cursor-pointer hover:bg-blue-700 transition-colors shadow-sm hover:shadow-md text-base">
                  <span class="material-symbols-outlined text-base mr-1.5">attach_file</span>
                  <span>Choisir un fichier</span>
                  <input 
                    type="file" 
                    (change)="fileChange($event)" 
                    class="hidden"
                    accept=".xlsx,.xls">
                </label>
              </div>
              <div *ngIf="nouveauMessage.fileName" class="flex items-center gap-2 text-base text-gray-700 font-medium bg-white px-3 py-2 rounded-lg border border-gray-200">
                <span class="material-symbols-outlined text-green-600 text-lg">check_circle</span>
                <span class="max-w-xs truncate">{{ nouveauMessage.fileName }}</span>
              </div>
            </div>
          </div>
          <div *ngIf="upload" class="mt-2 flex items-center gap-2 text-blue-600">
            <div class="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <span class="text-sm font-medium">Fichier en cours de téléchargement...</span>
          </div>
          <p *ngIf="error.destinataire" class="campagne-error">
            <span *ngIf="nouveauMessage.messageUnique === '1'">Merci d'importer des destinataires</span>
            <span *ngIf="nouveauMessage.messageUnique === '0'">Merci d'importer votre fichier client avec les numéros et messages</span>
          </p>
        </div>

        <div class="flex justify-end pt-3 border-t border-gray-200">
          <button 
            type="submit"
            class="campagne-btn-primary"
            [disabled]="upload || isCreating">
            <span *ngIf="!isCreating" class="flex items-center gap-2">
              <span class="material-symbols-outlined text-base">add</span>
              <span>Créer</span>
            </span>
            <span *ngIf="isCreating" class="flex items-center gap-2">
              <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Création en cours...</span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<app-confirmation-modal
  [isVisible]="showModal"
  [config]="modalConfig"
  (confirm)="onModalConfirm()"
  (cancel)="onModalClose()"
  (close)="onModalClose()">
</app-confirmation-modal>
